import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import HomePage from './Pages/HomePage';
import GamePage from './Pages/GamesPage';
import SubscribePage from './Pages/SubscribePage';
import LoginPage from './Pages/LoginPage';
import OtpPage from './Pages/OtpPage';
import ConfirmationPage from './Pages/ConfirmationPage';
import GamePlexPlans from './Pages/GamePlexPlans';

const App = () => {
  const router=createBrowserRouter([
    {
      path:"/",
      element:<HomePage />
    },
    {
      path:"/games/:id/:name",
      element:<GamePage />
    },
    {
      path:"/subscribe",
      element:<GamePlexPlans/>
    },
   {
      path: "/login",
      element: <LoginPage />
    },    {
      path: "/otp",
      element: <OtpPage />
    },  {
      path: "/confirmation",
      element: <ConfirmationPage />
    },
  ])
  return (
    <RouterProvider router={router} />
  )
}

export default App